import { IReplyTicket } from "../../../types/common.interface";
import customAxios from "../../customAxios";

import { REPLY_TICKET } from "../../routes";

const replyTicket = async (formData: IReplyTicket) => {
  try {
    return (
      await customAxios.post(REPLY_TICKET + "/" + formData?._id, {
        ...formData,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ REPLY_TICKET: error });
    return false;
  }
};

export default replyTicket;
